import { render, staticRenderFns } from "./PassbookWithDrawal.vue?vue&type=template&id=0d4a9318&scoped=true&"
import script from "./PassbookWithDrawal.vue?vue&type=script&lang=js&"
export * from "./PassbookWithDrawal.vue?vue&type=script&lang=js&"
import style0 from "./PassbookWithDrawal.vue?vue&type=style&index=0&id=0d4a9318&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4a9318",
  null
  
)

export default component.exports